import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const IntroPisoDePvcRigido = () => {
  return (
    <section>
      <div className="container">
        <div className="row g-xxl-5 align-items-end mt-n1-9">
          {/* Columna izquierda con imagen y características */}
          <div className="col-lg-6 order-2 order-lg-1 mt-1-9">
            <div className="pe-lg-1-6 pe-xl-6">
              <img src="/assets/img/productos/piso-de-pvc-rigido/piso-de-pvc-rigido-amarillo.jpg" alt="piso de pvc rigido amarillo" className="mb-6 mb-xl-10" />
              <div className="ps-lg-10 ps-xl-20">
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Fácil instalación"
                  descripcion="Su diseño modular tipo rompecabezas permite un montaje rápido y sin complicaciones."
                />
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Uso en interiores y exteriores"
                  descripcion="Resiste los cambios climáticos sin sufrir deterioro, lo que lo hace perfecto para cualquier entorno."
                />
              </div>
            </div>
          </div>
          
          {/* Columna derecha con título y párrafo */}
          <div className="col-lg-6 order-1 order-lg-2 mt-1-9">
            <div className="ps-lg-1-6 ps-xl-6">
              <div className="title-style1 mb-1-9 mb-lg-10 mb-xl-15">
                <span>Entrega Inmediata</span>
                <h2 className="h1 mb-4">Piso de PVC Modular Rígido</h2>
                <p className="mb-0">
                El Piso de PVC Modular Rígido está diseñado para soportar alto tráfico gracias a sus uniones tipo rompecabezas, que garantizan un ajuste perfecto 
                entre cada pieza. Es ideal para bodegas, oficinas, salones de fiestas y otros espacios de uso intensivo.
                Fabricado con polivinilo de alta densidad, este piso está pensado para maximizar su resistencia y durabilidad en condiciones de uso rudo.
                </p>
              </div>
              <BannerNoInstalacion />
              <img src="/assets/img/productos/piso-de-pvc-rigido/piso-de-pvc-rigido-amarillo-atras.jpg" alt="piso de pvc rigido amarillo" /> 
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para las características individuales
const FeatureItem = ({ imgSrc, titulo, descripcion }) => {
  return (
    <div className="d-flex border-bottom pb-1-9 mb-1-9">
      <div className="flex-shrink-0 me-4">
        <img src={imgSrc} alt={titulo} />
      </div>
      <div className="flex-grow-1">
        <h4 className="h5">{titulo}</h4>
        <p className="mb-0">{descripcion}</p>
      </div>
    </div>
  );
};

export default IntroPisoDePvcRigido;
